import React from 'react';
import PageBanner from "@/components/pageBanner";
import {Heading} from "@/components/ui/heading";
import {ReactComponent as QuoteSvg} from "../assets/images/icons/quote.svg";

const About = () => {
    return (
        <main id="about-us-page">
            <PageBanner title="About Us" slug="about-us" />
            <section className="generic-container py-14">
                <div style={{textAlign: 'center'}}>
                    <Heading level={2}>Locked Trade – Your Future in Financial Markets</Heading>
                </div>
                <Heading level={3}>
                    Locked Trade was born out of a passion for investing and innovation.<br/>
                    We are a team of professionals united by one goal:<br/>
                    to create tools that truly transform the trading experience<br/>
                    and support traders at every stage of their journey.
                </Heading>
            </section>
            <section className="dark-bg-with-gradients">
                <section className="generic-container py-20">
                    <div className={`quote-paragraph`}>
                        <QuoteSvg className={`quote-svg-before`}/>
                        <p>Since 2016, we have been continuously developing our platform, introducing
                            solutions that are not only modern but also highly practical. This year, we made a
                            groundbreaking
                            change – our Virtual Assistant has been enhanced with Artificial Intelligence (AI),
                            significantly
                            improving its capabilities as a market analysis tool.</p>
                        <QuoteSvg className={`quote-svg-after`}/>
                    </div>
                </section>
            </section>
            <section className="generic-container py-14">
                <Heading level={3} style={{ marginTop: '0' }}>
                    Thanks to this innovation,<br/>
                    traders now have access to real-time market analyses<br/>
                    and personalized recommendations tailored to their individual trading styles.
                </Heading>
            </section>
        </main>
    );
};

export default About;